<template>
  <modal
    name="modal-configuracao-usuario"
    scrollable
    :width="500"
    height="auto"
  >
    <button
      type="button"
      class="close mt-3 mr-3"
      aria-label="Fechar configurações"
      @click="$modal.hide('modal-configuracao-usuario')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
    <div class="modal-config-container">
      <span class="config-eyebrow">PREFERÊNCIAS DO EDITOR</span>
      <h3>Configurações</h3>
      <p class="config-intro">Ajuste a visualização do editor de fluxos.</p>
      <div class="config-options-container">
        <div v-if="mostrarAlternanciaEditor" class="config-section">
          <div>
            <label class="config-title" for="novo-editor-fluxo">
              Novo editor de fluxo <span class="config-beta">Beta</span>
            </label>
            <p>Versão beta em tela ampla. Você pode voltar ao editor atual.</p>
          </div>
          <InputSwitch
            inputId="novo-editor-fluxo"
            :value="novoEditorAtivo"
            :disabled="alternanciaEditorDesabilitada"
            @input="$emit('alternar-editor')"
          />
        </div>
        <div class="config-section">
          <div>
            <label class="config-title" for="stages_by_category"
              >Separar por categoria</label
            >
            <p>Organiza a biblioteca de estágios por tipo.</p>
          </div>
          <InputSwitch
            id="stages_by_category"
            v-model="usuario_config.stages_by_category"
          />
        </div>
        <div class="config-section">
          <label class="config-title" for="default_initial_zoom"
            >Zoom inicial</label
          >
          <b-form-select
            id="default_initial_zoom"
            v-model="usuario_config.default_initial_zoom"
            :options="zoom_options"
            class="config-zoom"
          />
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import API_LINKS from "../../api.links";
import ApiService from "@/core/services/api.service";
import InputSwitch from "primevue/inputswitch";

export default {
  components: {
    InputSwitch
  },
  props: {
    usuario_config: {
      type: Object,
      required: true
    },
    mostrarAlternanciaEditor: {
      type: Boolean,
      default: false
    },
    novoEditorAtivo: {
      type: Boolean,
      default: false
    },
    alternanciaEditorDesabilitada: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      zoom_options: [
        { text: "150%", value: 1.5 },
        { text: "140%", value: 1.4 },
        { text: "130%", value: 1.3 },
        { text: "120%", value: 1.2 },
        { text: "110%", value: 1.1 },
        { text: "100%", value: 1 },
        { text: "90%", value: 0.9 },
        { text: "80%", value: 0.8 },
        { text: "70%", value: 0.7 },
        { text: "60%", value: 0.6 },
        { text: "50%", value: 0.5 }
      ]
    };
  },
  methods: {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
.modal-config-container {
  padding: 30px;
  color: #29223a;
  .config-eyebrow {
    color: #462181;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.1em;
  }
  h3 {
    font-size: 22px;
    font-weight: 700;
    margin: 5px 0 6px;
  }
  .config-intro {
    color: #777183;
    font-size: 13px;
    margin-bottom: 24px;
  }
  .config-options-container {
    display: flex;
    flex-direction: column;
    gap: 18px;
    .config-section {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      p {
        color: #777183;
        font-size: 12px;
        margin: 3px 0 0;
      }
    }
  }
  .config-title {
    font-size: 13px;
    font-weight: 700;
    margin: 0;
  }
  .config-beta {
    background: #f0e9fa;
    border: 1px solid #d9c7ef;
    border-radius: 999px;
    color: #623a94;
    display: inline-block;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.04em;
    margin-left: 5px;
    padding: 2px 7px;
    text-transform: uppercase;
    vertical-align: middle;
  }
  .config-zoom {
    max-width: 120px;
  }
}
</style>
